import { useCallback } from "react";
function useInputKeyDownHandler(_ref) {
  var onKeyDown = _ref.onKeyDown, inputFormat = _ref.inputFormat;
  return useCallback(function(event) {
    if (event.keyCode === BACKSPACE_KEY_CODE && inputFormat === "INTERNATIONAL" && event.target instanceof HTMLInputElement && getCaretPosition(event.target) === LEADING_PLUS.length) {
      event.preventDefault();
      return;
    }
    onKeyDown && onKeyDown(event);
  }, [onKeyDown, inputFormat]);
}
function getCaretPosition(element) {
  return element.selectionStart;
}
var BACKSPACE_KEY_CODE = 8, LEADING_PLUS = "+";
export {
  useInputKeyDownHandler as default
};
//# sourceMappingURL=useInputKeyDownHandler.js.map
